var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cnmn-file-drop",on:{"click":_vm.click}},[_c('cnmn-file-input',_vm._g(_vm._b({ref:"input",staticClass:"cnmn-file-drop__input"},'cnmn-file-input',_vm.$attrs,false),_vm.$listeners)),_c('div',[_vm._v("工事中")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }